import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function deleteCompany(
  companyId: string,
  auth: Authentication
): Promise<void> {
  try {
    await HttpClient.delete(
      '/company',
      {
        companyId,
      },
      auth.token,
      {
        'x-company-id': companyId,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new DeleteSubscriptionFailure();
  }
}

export class DeleteSubscriptionFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteCompany;
